import { useState, useRef, useEffect, useContext } from "react";
import { Lock, Smartphone, Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalContext } from "../../Context/GlobalContext";
import facebook from "../../Assets/facebook.jpeg";
import google from "../../Assets/google-logo.png";
import image1 from "../../Assets/image1.jpg";
import image2 from "../../Assets/image2.jpg";
import image3 from "../../Assets/image3.jpg";
import image4 from "../../Assets/image4.jpg";
import image5 from "../../Assets/image5.jpg";
import title from "../../Assets/title.svg";
import anlook_logo from "../../Assets/anlook_logo.png";
import chaafo from "../../Assets/chaafo";
import chaafo_image from "../../Assets/chaafo_image.png";
import Trawlo from "../../Assets/Trawlo.svg";
import packkys from "../../Assets/packkys.svg";
import Packky from "../../Assets/Packky.png";
import Icon from "../../Assets/Logo.png";
import Logo from "../../Assets/Icon.svg";

const LoginPage = ({ onLogin }) => {
  const { api, setCurrentAdmin } = useContext(GlobalContext);

  const [form, setForm] = useState({ mobile: "", password: "" });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [location, setLocation] = useState({ lat: "", lng: "" });

  const passwordRef = useRef("");
  const otpRefs = useRef([]);
  const navigate = useNavigate();

  const companies = [
    {
      name: (
        <img
          src={Trawlo}
          alt="Trawlo"
          style={{ height: "50px", width: "100px", padding: "2px" }}
        />
      ),
      icon: (
        <img
          src={Trawlo}
          alt="Trawlo"
          style={{
            height: "100px",
            width: "100px",
            borderRadius: "50%",
            padding: "2px",
          }}
        />
      ),
    },
    {
      name: (
        <img
          src={chaafo_image}
          alt="chaafo"
          style={{ height: "50px", width: "220px", padding: "2px" }}
        />
      ),
      icon: (
        <img
          src={chaafo}
          alt="chaafo"
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            padding: "5px",
          }}
        />
      ),
    },
    {
      name: (
        <img
          src={anlook_logo}
          alt="anlook"
          style={{ height: "50px", width: "220px", padding: "2px" }}
        />
      ),
      icon: (
        <img
          src={title}
          alt="anlook"
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            padding: "5px",
          }}
        />
      ),
    },
    {
      name: (
        <img
          src={Packky}
          alt="packky"
          style={{ height: "60px", width: "100px", padding: "2px" }}
        />
      ),
      icon: (
        <img
          src={packkys}
          alt="Packky"
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            padding: "5px",
          }}
        />
      ),
    },
    {
      name: (
        <img
          src={Icon}
          alt="shubhpaisa"
          style={{ height: "60px", width: "80px", padding: "2px" }}
        />
      ),
      icon: (
        <img
          src={Logo}
          alt="shubhpaisa"
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            padding: "5px",
          }}
        />
      ),
    },
  ];

  const loopCompanies = [...companies, ...companies];

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          setLocation({
            lat: String(pos.coords.latitude),
            lng: String(pos.coords.longitude),
          }),
        () => {}
      );
    }
  }, []);

  useEffect(() => {
    if (form.password !== undefined) {
      passwordRef.current = form.password;
      if (form.password) {
        sessionStorage.setItem("login_pw_cache", form.password);
      }
    }
  }, [form.password]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const updated = [...otp];
      updated[index] = value;
      setOtp(updated);
      if (value && index < 5) otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const isFormValid = () => {
    if (!/^[0-9]{10}$/.test(form.mobile.trim())) {
      toast.error("Enter a valid 10-digit mobile number.");
      return false;
    }
    if (step === 1 && !form.password.trim()) {
      toast.error("Please enter your password.");
      return false;
    }
    if (step === 2 && otp.join("").length !== 6) {
      toast.error("Please enter full 6-digit OTP.");
      return false;
    }
    return true;
  };

  const buildPayload = () => {
    const cachedPw = sessionStorage.getItem("login_pw_cache") || "";
    const safePassword = form.password || passwordRef.current || cachedPw;

    const base = {
      mobile: form.mobile,
      step: String(step),
      latitude: location.lat,
      longitude: location.lng,
      password: safePassword,
    };

    return step === 2 ? { ...base, otp: otp.join("") } : base;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) return;

    setLoading(true);
    try {
      const res = await api.post(`/Admin/login`, buildPayload());

      if (res?.data?.responseCode === "00") {
        if (step === 1) {
          toast.success("Password verified! Enter OTP.");
          setStep(2);
          return;
        }

        const data = res?.data?.response || {};

        const adminMeta = {
          adminId: data.pkid ?? "",
          adminNo: data.adminno ?? "",
          name: data.adname ?? "",
          roleId: data.fk_role_id ?? "",
          roleName: data.rolename ?? "",
          portalId: data.portalId ?? "",
          mobile: data.mobile ?? "",
          userType: data.userType ?? "",
        };

        const token = data.token || data.accessToken || null;
        const user = {
          id: data.pkid ?? data.id ?? "",
          name: data.adname ?? data.name ?? "",
        };
        const expiresAt = data.expiresAt || null;

        const userData = {
          isAuthenticated: true,
          user,
          token,
          adminMeta,
          rawLoginResponse: data,
          loginAt: Date.now(),
          expiresAt,
        };

        sessionStorage.setItem("userData", JSON.stringify(userData));
        setCurrentAdmin(adminMeta);
        sessionStorage.removeItem("login_pw_cache");

        toast.success("Login successful!");
        onLogin?.();
        navigate("/");
      } else {
        toast.error(res?.data?.responseMessage || "Login failed!");
      }
    } catch (err) {
      console.error(" Login error:", err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="container mx-auto p-4 lg:p-12">
          <div className="relative hidden lg:flex justify-center">
            <div className="absolute w-[700px] h-[700px] rounded-full bg-gradient-radial from-[#4f6ff3] to-transparent top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-80" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
            {/* Left Form */}
            <div className="flex justify-center">
              <div className="relative w-full max-w-md">
                <div className="absolute w-[140px] h-[140px] rounded-full bg-gradient-to-b from-[#7ea0ff] to-[#3558d6] -top-4 -left-16 animate-float opacity-60" />
                <div className="absolute w-[120px] h-[120px] rounded-full bg-gradient-to-b from-[#7ea0ff] to-[#3558d6] -bottom-6 -right-12 animate-float opacity-60" />

                <div className="bg-white/20 backdrop-blur-lg border border-gray-200/50 rounded-xl p-6 relative z-10 max-w-md">
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <p className="text-2xl font-semibold text-white mb-4 mt-3">
                      Please enter your <br /> Account Details
                    </p>

                    {/* Mobile */}
                    <div>
                      <label className="text-white font-semibold block mb-1">
                        Mobile
                      </label>
                      <div className="flex items-center bg-white rounded-lg overflow-hidden">
                        <span className="p-2 text-gray-500">
                          <Smartphone size={20} />
                        </span>
                        <input
                          type="text"
                          name="mobile"
                          value={form.mobile}
                          onChange={handleChange}
                          placeholder="84049*****"
                          className="flex-1 p-2 outline-none bg-transparent text-gray-800"
                          autoComplete="tel"
                          inputMode="numeric"
                        />
                      </div>
                    </div>

                    {/* Password (Step 1 ) */}
                    {step === 1 && (
                      <div>
                        <label className="text-white font-semibold block mb-1">
                          Password
                        </label>
                        <div className="flex items-center bg-white rounded-lg overflow-hidden">
                          <span className="p-2 text-gray-500">
                            <Lock size={20} />
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="password@1234"
                            className="flex-1 p-2 outline-none bg-transparent text-gray-800"
                            autoComplete="current-password"
                          />
                          <button
                            type="button"
                            className="p-2"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <EyeOff size={20} className="text-gray-500" />
                            ) : (
                              <Eye size={20} className="text-gray-500" />
                            )}
                          </button>
                        </div>
                      </div>
                    )}

                    {/* OTP (Step 2) */}
                    {step === 2 && (
                      <div>
                        <label className="text-white font-semibold block mb-1">
                          OTP
                        </label>
                        <div className="flex gap-2">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (otpRefs.current[index] = el)}
                              type="text"
                              maxLength="1"
                              value={digit}
                              onChange={(e) => handleOtpChange(e, index)}
                              onKeyDown={(e) => handleOtpKeyDown(e, index)}
                              className="w-12 h-12 text-center border-2 border-[#4f6ff3] text-gray-800 text-lg rounded-lg focus:outline-none"
                              inputMode="numeric"
                            />
                          ))}
                        </div>
                        <p className="text-center text-white text-sm mt-2">
                          We&apos;ve sent a verification code to your mobile
                          number
                        </p>
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full py-2 rounded-lg font-bold text-white transition bg-[#4f6ff3] hover:bg-[#3a58dc]"
                    >
                      {loading
                        ? "Processing..."
                        : step === 2
                        ? "Verify & Login"
                        : "Continue"}
                    </button>
                  </form>

                  <div className="flex items-center justify-center gap-6 mt-6">
                    <img
                      src={google}
                      alt="Google"
                      className="h-11 w-11 rounded-full p-1 cursor-pointer bg-white"
                    />
                    <img
                      src={facebook}
                      alt="Facebook"
                      className="h-11 w-11 rounded-full p-2 cursor-pointer bg-white"
                    />
                  </div>

                  <p className="text-center mt-8 text-sm text-white">
                    <a href="#" className="underline">
                      Create an account
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Right Info Card*/}
            <div className="hidden lg:flex justify-end relative">
              <div className="absolute top-1/2 left-1/4 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full opacity-90 bg-[radial-gradient(circle,_#4f6ff3_0%,_rgba(79,111,243,0)_70%)] z-0"></div>
              <div className="absolute -top-6 left-12 w-[140px] h-[140px] rounded-full opacity-60 animate-float bg-gradient-to-b from-[#9ab2ff] to-[#4f6ff3]"></div>
              <div className="absolute -bottom-6 -right-12 w-[120px] h-[120px] rounded-full opacity-60 animate-float delay-1000 bg-gradient-to-b from-[#9ab2ff] to-[#4f6ff3]"></div>

              <div
                className="relative w-[400px] h-[600px] text-white"
                style={{
                  clipPath:
                    "path('M 0,30 Q 0,0 30,0 L 280,0 Q 320,0 320,40 Q 320,70 370,60 Q 400,60 400,85 L 400,570 Q 400,600 370,600 L 30,600 Q 0,600 0,570 Z')",
                  background: "linear-gradient(180deg, #6f8cff, #2a45c0)",
                }}
              >
                <h1 className="text-2xl font-bold mt-5 ml-7">
                  This is Bumppy Sales <br /> Admin Page
                </h1>
                <p className="mt-5 ml-7 text-lg">
                  Here we can access all services. After <br /> login that we
                  can manage all things
                </p>

                <div className="w-full mt-5">
                  <div className="scroll-container overflow-x-auto">
                    <div className="scroll-content flex gap-4 w-max">
                      {loopCompanies.map((company, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-3 cursor-pointer px-4 py-2 rounded-full min-w-max"
                        >
                          <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm">
                            {company.icon}
                          </div>
                          <span className="text-lg font-medium text-gray-800">
                            {company.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="absolute top-[315px] right-10 w-[55px] h-[55px] rounded-full bg-white flex items-center justify-center z-10">
                  <span className="text-[50px] text-gray-800 font-bold mt-4">
                    *
                  </span>
                </div>

                <div
                  className="absolute bottom-0 left-0 m-7 w-[350px] h-[250px] bg-white text-gray-700"
                  style={{
                    clipPath:
                      "path('M 0,12 Q 0,0 18,0 L 228,0 Q 260,0 260,20 Q 260,70 315,60 Q 340,60 340,80 L 340,225 Q 340,255 315,250 L 30,250 Q 0,255 0,237 Z')",
                  }}
                >
                  <h1 className="text-2xl font-semibold mt-5 mx-4">
                    This is Bumppy Sales <br /> Admin Page
                  </h1>
                  <p className="mt-4 mx-4 text-lg">
                    Here we can access all services. After <br /> login that we
                    can manage all things
                  </p>

                  <div className="flex items-center mx-4 mt-4">
                    {[image1, image2, image3, image4, image5].map(
                      (img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt=""
                          className="w-10 h-10 rounded-full border border-white object-cover"
                          style={{
                            marginLeft: index === 0 ? "0" : "-10px",
                            zIndex: 5 - index,
                          }}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(10px); }
            50% { transform: translateY(-20px); }
          }
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
          .delay-1000 {
            animation-delay: 1s;
          }
          .scroll-container {
            width: 100%;
            overflow: hidden;
          }
          .scroll-content {
            display: flex;
            width: max-content;
            animation: infiniteScroll 20s linear infinite;
          }
          @keyframes infiniteScroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .scroll-content:hover {
            animation-play-state: paused;
          }
        `}</style>
    </>
  );
};

export default LoginPage;
